import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { PrimaryButton } from '../../components';
import css from './ListingPage.module.css';

const SectionInquiry = props => {
  const { onContactUser } = props;

  return (
    <section className={css.root}>
      <div className={css.content}>
        <h2 className={css.heading}>
          <FormattedMessage id="SectionInquiry.heading" />
        </h2>

        <p className={css.description}>
          <FormattedMessage id="SectionInquiry.description" />
        </p>

        <PrimaryButton
         className={css.inquiryButton}
         onClick={onContactUser}
         >
          <FormattedMessage id="SectionInquiry.contactButton" />
        </PrimaryButton>
      </div>
    </section>
  );
};

export default SectionInquiry;
